export const BANK_CONFIGURATIONS_RESET_STATE = 'BANK_CONFIGURATIONS_RESET_STATE';
export const BANK_CONFIGURATIONS_CURRENT_ITEM = 'BANK_CONFIGURATIONS_CURRENT_ITEM';

export const BANK_CONFIGURATIONS_REQUEST_LOADING = 'BANK_CONFIGURATIONS_REQUEST_LOADING';
export const BANK_CONFIGURATIONS_REQUEST_SUCCESS = 'BANK_CONFIGURATIONS_REQUEST_SUCCESS';
export const BANK_CONFIGURATIONS_REQUEST_FAILED = 'BANK_CONFIGURATIONS_REQUEST_FAILED';

export const BANK_CONFIGURATIONS_CURRENT_ACTION = 'BANK_CONFIGURATIONS_CURRENT_ACTION';
export const BANK_CONFIGURATIONS_RESET_ACTION = 'BANK_CONFIGURATIONS_RESET_ACTION';